import React from 'react'

import {
  DeleteOutlined,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'

function RemoveIcon() {
  return <DeleteOutlined width="24" height="24" />
}

export default RemoveIcon
